import React from 'react';

import { ButtonProps, SelectListFilter } from '@sandtech-hub-monorepo/ui-kit';
import { useGeoPicker } from './picker';

export const CountryPicker = ({
  selected,
  handleOnSelect,
  triggerVariant,
  triggerClassName,
}: {
  selected?: string;
  handleOnSelect?: (item: { value: string; label: string }) => void;
  triggerVariant?: ButtonProps['variant'];
  triggerClassName?: string;
}) => {
  const { getCountries } = useGeoPicker();

  return (
    <SelectListFilter
      items={getCountries()}
      defaultValue={selected}
      handleChange={handleOnSelect}
      variant={triggerVariant}
      triggerClassName={triggerClassName}
    />
  );
};
